import React from 'react';
import errorAPI from '../../api/error-api/ErrorAPI';
import { translate } from '../../api/string-api/StringAPI';

/**
 * Contains the text portion of the ErrorPage.
 * Extracts string from StringAPI category Error
 * @constructor
 */
const ErrorDescription = function () {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="text-4xl">
        <span className="font-semibold">{translate('ERROR_TITLE_ONE')}</span>
        {translate('ERROR_TITLE_TWO')}
        <hr className="westland-red border-2" />
      </div>
      <div className="mt-2 text-xl">{translate('ERROR_SUBTITLE')}</div>
      <div className="mt-2 mb-2 flex justify-center items-center text-xs">
        {/* { */}
        <span className="text-5xl mr-2">&#123;</span>
        <div>
          <div className="text-sm">
            <span className="error">{translate('ERROR_MESSAGE')}</span>
            {errorAPI.getErrorMessage()}
          </div>
          <div className="text-sm">
            <span className="error">{translate('ERROR_CODE')}</span>
            {errorAPI.getErrorCode()}
          </div>
        </div>
        {/* } */}
        <span className="text-5xl ml-2 ">&#125;</span>
      </div>
    </div>
  );
};

export default ErrorDescription;
